export enum SortDirections {
  ASC = 'asc',
  DSC = 'dsc',
}

export type ColumnType = {
  label: string;
  hideLabel?: boolean;
  rightAlign?: boolean;
  selector?: Function;
  component?: React.ReactNode;
  isSortable?: boolean;
  sort?: SortDirections;
  maxWidth?: string;
  showColumn?: boolean;
};

export type DataType = {
  /** Allow other data for custom option */
  [x: string]: any;
};

export type WpDataTableProps = {
  tableId: string;
  columns: ColumnType[];
  data: DataType[];
  striped?: boolean;
  rowClick?: Function;
  showHeader?: boolean;
  showInContainer?: boolean;
  isLoading?: boolean;
  slimRow?: boolean;
  showBorder?: boolean;
  nestedKey?: Function;
  uniqueIdentifier?: Function;
  labelIdentifier?: Function;
  singleItemLabel?: string;
  pluralItemLabel?: string;
  selectedItems?: DataType[];
  selectableSelector?: Function;
  // this is needed for the windows scrolling to set
  // a height for the upper and lower bounds
  maxHeight?: string;
  // for large list to allow render what is in the viewport
  windowedScrolling?: boolean;
  onSelect?: Function;
};

export type TableHeaderProps = {
  tableId: string;
  columns: ColumnType[];
  sortedColumn?: string;
  sortedDirection?: SortDirections;
  setSortColumn: Function;
  setSortDirection: Function;
  showBorder?: boolean;
  hasNesting?: boolean;
  selectable?: boolean;
  handleSelectAllChange: Function;
  data: DataType[];
  selectedRowKeys;
};

export type TableRowsProps = {
  tableId: string;
  columns: ColumnType[];
  data: DataType[];
  striped?: boolean;
  onClick?: Function;
  slimRow?: boolean;
  showBorder?: boolean;
  nestedKey?: Function;
  hasNesting?: boolean;
  handleSelectSubItem: Function;
  expandAll: boolean;
  singleItemLabel?: string;
  pluralItemLabel?: string;
  viewportRef?: React.RefObject<HTMLDivElement>;
  enableWindowScrolling?: boolean;
  selectable?: boolean;
  selectedRowKeys;
  handleSelectRow: Function;
  handleUnSelectRow: Function;
  selectableSelector?: Function;
};

export type TableBreadCrumbsProps = {
  tableId: string;
  data: DataType[];
  selectedData: DataType[];
  uniqueIdentifier?: Function;
  labelIdentifier?: Function;
  nestedKey?: Function;
  handleSelectSubItem: Function;
  pluralItemLabel?: string;
};
